import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AvisoLegal.css';

const AvisoLegal: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="aviso-page">
      <header className="aviso-header">
        <div className="aviso-header-content">
          <div className="aviso-logo" onClick={() => navigate('/')}>
            <img src="/logo_transp.png" alt="ContratoSeguro" />
          </div>
          <button onClick={() => navigate('/')} className="btn-back">
            Voltar para o inicio
          </button>
        </div>
      </header>

      <main className="aviso-main">
        <div className="aviso-container">
          <div className="aviso-content">
            <h1>AVISO LEGAL — CONTRATOSEGURO</h1>
            <p className="aviso-updated">Última atualização: 6 de fevereiro de 2026</p>

            <p className="aviso-intro">
              O presente <strong>Aviso Legal</strong> tem como objetivo esclarecer a natureza dos
              servicos prestados pelo <strong>ContratoSeguro</strong>, bem como estabelecer limites
              de responsabilidade e orientacoes importantes aos usuarios da plataforma.
            </p>
            <p className="aviso-intro">
              Para entregar as analises, o ContratoSeguro processa e armazena os dados constantes
              nos contratos enviados, inclusive informacoes pessoais identificaveis das partes
              (locadores, locatarios, fiadores e testemunhas), de forma estruturada e segura,
              conforme nossas politicas de privacidade, cookies e termos de uso.
            </p>

            <section className="aviso-section">
              <h2>1. Natureza do servico</h2>
              <p>
                O <strong>ContratoSeguro</strong> e uma plataforma digital que utiliza
                <strong> inteligencia artificial</strong> para realizar <strong>analises automatizadas</strong>
                de contratos, atualmente com foco em <strong>contratos de locacao residencial</strong>.
              </p>
              <p>
                As informacoes fornecidas pela plataforma tem carater <strong>informativo</strong>,
                <strong> educacional</strong> e <strong>explicativo</strong>, com o objetivo de auxiliar
                o usuario na compreensao geral do conteudo do contrato.
              </p>
            </section>

            <section className="aviso-section">
              <h2>2. Nao prestacao de consultoria juridica</h2>
              <p className="aviso-warning">O ContratoSeguro NAO e um escritorio de advocacia.</p>
              <p className="aviso-warning">O ContratoSeguro NAO presta consultoria juridica.</p>
              <p className="aviso-warning">O ContratoSeguro NAO substitui a atuacao de um advogado habilitado.</p>
              <p>Nenhuma informacao disponibilizada na plataforma deve ser interpretada como:</p>
              <ul>
                <li>Parecer juridico</li>
                <li>Opiniao legal definitiva</li>
                <li>Recomendacao juridica personalizada</li>
                <li>Substituicao de aconselhamento profissional</li>
              </ul>
              <p>
                Para situacoes especificas ou decisoes juridicas relevantes, o usuario deve consultar
                um advogado devidamente inscrito na OAB.
              </p>
            </section>

            <section className="aviso-section">
              <h2>3. Limitacoes das analises automatizadas</h2>
              <p>O usuario reconhece e concorda que:</p>
              <ul>
                <li>As analises sao realizadas de forma automatizada e podem conter erros ou omissoes.</li>
                <li>A precisao depende da qualidade, legibilidade e completude do documento enviado.</li>
                <li>A plataforma pode nao identificar todas as clausulas relevantes ou riscos existentes.</li>
                <li>A legislacao pode sofrer alteracoes que nao estejam refletidas imediatamente nas analises.</li>
              </ul>
            </section>

            <section className="aviso-section">
              <h2>4. Responsabilidade do usuario</h2>
              <p>O uso das informacoes fornecidas pelo ContratoSeguro e de responsabilidade exclusiva do usuario.</p>
              <p>O usuario e o unico responsavel por:</p>
              <ul>
                <li>Avaliar as informacoes recebidas</li>
                <li>Tomar decisoes relacionadas a assinatura, negociacao ou rescisao de contratos</li>
                <li>Verificar a adequacao das clausulas a sua situacao especifica</li>
                <li>Buscar orientacao juridica profissional quando necessario</li>
                <li>Garantir que possui autorizacao ou base legal para enviar dados pessoais de terceiros contidos nos contratos</li>
              </ul>
            </section>

            <section className="aviso-section">
              <h2>5. Limitacao de responsabilidade</h2>
              <p>
                Na maxima extensao permitida pela legislacao brasileira, o ContratoSeguro nao se
                responsabiliza por:
              </p>
              <ul>
                <li>Danos diretos ou indiretos decorrentes do uso da plataforma</li>
                <li>Perdas financeiras, lucros cessantes ou prejuizos de qualquer natureza</li>
                <li>Decisoes tomadas com base nas analises fornecidas</li>
                <li>Eventuais falhas, interrupcoes ou indisponibilidades do servico</li>
                <li>Interpretacoes divergentes da legislacao aplicavel</li>
                <li>Qualquer uso ou compartilhamento indevido de dados pessoais de terceiros informado pelo usuario</li>
              </ul>
              <p>
                Quando aplicavel, eventual responsabilidade do ContratoSeguro ficara limitada ao valor
                efetivamente pago pelo usuario nos ultimos 12 (doze) meses.
              </p>
            </section>

            <section className="aviso-section">
              <h2>6. Links para legislacao e conteudos externos</h2>
              <p>
                A plataforma pode apresentar links para leis, normas ou sites externos apenas para fins
                informativos.
              </p>
              <p>
                O ContratoSeguro nao se responsabiliza pelo conteudo, atualizacao ou interpretacao de
                informacoes disponibilizadas por terceiros.
              </p>
            </section>

            <section className="aviso-section">
              <h2>7. Atualizacoes do aviso legal</h2>
              <p>
                Este Aviso Legal pode ser alterado a qualquer momento, a fim de refletir mudancas legais,
                tecnicas ou operacionais.
              </p>
              <p>A versao mais recente estara sempre disponivel na plataforma.</p>
              <p>O uso continuo do servico apos alteracoes implica aceitacao do novo Aviso Legal.</p>
            </section>

            <section className="aviso-section">
              <h2>8. Contato</h2>
              <p>Para duvidas ou esclarecimentos sobre este Aviso Legal, entre em contato:</p>
              <p>📧 <strong>contato@contratoseguro.com</strong></p>
            </section>

            <div className="aviso-acceptance">
              <p><strong>ContratoSeguro</strong></p>
              <p><em>Clareza para quem assina. Seguranca para quem decide.</em></p>
            </div>
          </div>
        </div>
      </main>

      <footer className="aviso-footer">
        <div className="aviso-footer-content">
          <p>&copy; 2026 ContratoSeguro. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
};

export default AvisoLegal;
